
import './App.css';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import Contact from './Components/Contact';
function App() {
  return (
   <>
<Navbar/>
<Home/>
<Contact/>
   </>
  );
}

export default App;
